import React from "react";

const NoNotification = (props) => {
  return (
    <svg
      width="97"
      height="89"
      viewBox="0 0 97 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.12032 66.4427C1.55261 66.2889 2.00711 66.0842 2.35787 65.7876C2.77442 65.4356 2.94394 64.9823 3.05777 64.5052C3.20389 63.8921 3.26201 63.2394 3.43921 62.6251C3.50459 62.397 3.63093 62.3111 3.68502 62.2727C3.82185 62.1762 3.9603 62.1504 4.09068 62.1601C4.24486 62.171 4.45677 62.2295 4.59603 62.4883C4.61581 62.525 4.64164 62.5815 4.65899 62.6586C4.67191 62.7155 4.67998 62.8923 4.6933 62.9654C4.7268 63.1454 4.75506 63.325 4.7813 63.5058C4.86888 64.108 4.91934 64.6191 5.19623 65.172C5.57202 65.9228 5.94861 66.3817 6.45961 66.5852C6.95326 66.7821 7.54378 66.745 8.29817 66.5908C8.36962 66.5735 8.44066 66.5585 8.51129 66.5464C8.84389 66.4883 9.16155 66.7067 9.22694 67.038C9.29233 67.369 9.08082 67.6915 8.75146 67.7646C8.68243 67.7795 8.61462 67.794 8.54762 67.807C7.52844 68.0596 6.34821 68.9602 5.66243 69.7489C5.45093 69.9918 5.14134 70.672 4.8257 71.1055C4.5928 71.4256 4.33084 71.6363 4.11126 71.7109C3.96393 71.761 3.83961 71.7533 3.73709 71.7279C3.58815 71.6912 3.46423 71.6104 3.36938 71.4821C3.31771 71.4118 3.26968 71.3178 3.24708 71.1975C3.23618 71.1394 3.23497 70.9925 3.23497 70.9259C3.17079 70.7047 3.09208 70.4887 3.03436 70.2651C2.89753 69.7323 2.62911 69.3953 2.30983 68.9497C2.01155 68.5323 1.69106 68.2703 1.22123 68.0613C1.16028 68.0463 0.667037 67.9256 0.49307 67.8562C0.23878 67.7549 0.117689 67.5846 0.0736923 67.4929C-0.000980254 67.3375 -0.00864926 67.2015 0.00628526 67.0885C0.0284852 66.921 0.103561 66.7781 0.236357 66.6627C0.318699 66.5908 0.441808 66.521 0.606895 66.4871C0.734847 66.4604 1.07269 66.4451 1.12032 66.4427ZM4.01277 65.5745C4.03578 65.6253 4.06 65.6766 4.08583 65.7282C4.63639 66.8273 5.25193 67.4413 5.99987 67.7392L6.0249 67.7488C5.52439 68.1202 5.07151 68.5355 4.72519 68.9339C4.58271 69.0978 4.3938 69.4385 4.18997 69.7876C4.0047 69.1854 3.70157 68.7595 3.32054 68.2267C3.02952 67.8199 2.72437 67.5139 2.34939 67.2645C2.64041 67.1155 2.91771 66.9404 3.15949 66.7365C3.56191 66.3963 3.82791 66.0023 4.01277 65.5745Z"
        fill="url(#paint0_linear_11190_137169)"
      />
      <path
        d="M12.1088 10.5604C13.4464 10.5604 14.5306 9.47614 14.5306 8.13861C14.5306 6.80108 13.4464 5.7168 12.1088 5.7168C10.7713 5.7168 9.68701 6.80108 9.68701 8.13861C9.68701 9.47614 10.7713 10.5604 12.1088 10.5604Z"
        fill="url(#paint1_linear_11190_137169)"
      />
      <path
        d="M94.4218 36.246C95.7593 36.246 96.8436 35.1617 96.8436 33.8242C96.8436 32.4866 95.7593 31.4023 94.4218 31.4023C93.0843 31.4023 92 32.4866 92 33.8242C92 35.1617 93.0843 36.246 94.4218 36.246Z"
        fill="url(#paint2_linear_11190_137169)"
      />
      <path
        d="M51.6854 72.6951C61.5051 72.6951 69.4656 64.7346 69.4656 54.9149C69.4656 45.0953 61.5051 37.1348 51.6854 37.1348C41.8658 37.1348 33.9053 45.0953 33.9053 54.9149C33.9053 64.7346 41.8658 72.6951 51.6854 72.6951Z"
        fill="url(#paint3_linear_11190_137169)"
      />
      <path
        d="M79.8261 41.6952V28.0543C79.8261 20.6137 76.8703 13.4782 71.6093 8.21681C66.3479 2.95582 59.2125 0 51.7718 0C44.3316 0 37.1958 2.95582 31.9348 8.21681C26.6734 13.4782 23.7175 20.6137 23.7175 28.0543V41.6952C23.718 44.829 22.8316 47.899 21.1605 50.5501C19.4895 53.2016 17.1024 55.3259 14.2753 56.6777C13.6254 56.9869 13.0769 57.4749 12.6935 58.084C12.31 58.6931 12.1074 59.3986 12.1094 60.1183V60.1922C12.109 60.4521 12.1598 60.7096 12.2587 60.9502C12.358 61.1904 12.5037 61.4087 12.6874 61.5928C12.8711 61.7768 13.089 61.9226 13.3292 62.0223C13.5693 62.122 13.8265 62.1732 14.0868 62.1732H89.4537C89.7136 62.1732 89.9707 62.122 90.2109 62.0223C90.451 61.9226 90.6694 61.7768 90.8531 61.5928C91.0367 61.4087 91.182 61.1904 91.2813 60.9502C91.3806 60.7096 91.4311 60.4521 91.4307 60.1922V60.1183C91.4311 59.401 91.228 58.6979 90.8454 58.0908C90.4627 57.4842 89.9162 56.9978 89.2688 56.6886C86.4397 55.336 84.0514 53.2101 82.3803 50.5566C80.7093 47.9035 79.8237 44.831 79.8261 41.6952Z"
        fill="#EBF1F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.6256 62.1601H12.1094V59.7383H91.6256V62.1601Z"
        fill="#011625"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.9125 68.3362C27.9791 70.0848 26.0509 71.7982 24.1688 73.6025C23.7627 73.9892 23.7474 74.6265 24.1316 75.0285C24.5171 75.4342 25.1585 75.4467 25.5609 75.0612C27.4334 73.2683 29.345 71.5694 31.2659 69.8329C31.6796 69.4567 31.7115 68.8178 31.3414 68.4073C30.966 67.9939 30.3262 67.9596 29.9125 68.3362Z"
        fill="#011625"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.5926 68.3386C75.5155 70.0876 77.4328 71.8014 79.3036 73.6057C79.7077 73.9924 79.7194 74.6297 79.3335 75.0305C78.9464 75.4354 78.3058 75.4475 77.9058 75.062C76.0443 73.269 74.1435 71.5693 72.2335 69.8329C71.8218 69.4563 71.7932 68.8182 72.1649 68.4081C72.5419 67.9955 73.1813 67.962 73.5926 68.3386Z"
        fill="#011625"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.5158 79.6354C50.4852 82.2368 50.4323 84.8104 50.4775 87.411C50.4852 87.9709 50.9421 88.4133 51.4975 88.4028C52.0565 88.3939 52.5009 87.9321 52.4912 87.3763C52.4485 84.7898 52.5005 82.238 52.5316 79.6544C52.5364 79.0961 52.09 78.6408 51.5379 78.6348C50.9804 78.6308 50.5211 79.0772 50.5158 79.6354Z"
        fill="#011625"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11190_137169"
          x1="0.232911"
          y1="66.953"
          x2="9.19958"
          y2="66.8929"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#249373" />
          <stop offset="1" stopColor="#0071C5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11190_137169"
          x1="9.80912"
          y1="8.13861"
          x2="14.5101"
          y2="8.10592"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#249373" />
          <stop offset="1" stopColor="#0071C5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11190_137169"
          x1="92.1221"
          y1="33.8242"
          x2="96.823"
          y2="33.7915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#249373" />
          <stop offset="1" stopColor="#0071C5" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_11190_137169"
          x1="34.8018"
          y1="54.9149"
          x2="69.3145"
          y2="54.6749"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#249373" />
          <stop offset="1" stopColor="#0071C5" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default NoNotification;
